import { $api } from "../generated/client";

/** Latest writes and exports of super admins, across every shop. */
export function useRecentSuperAdminActions(limit = 10) {
  return $api.useQuery(
    "get",
    "/super-admin/actions/recent",
    { params: { query: { limit } } },
    { refetchInterval: 60_000 },
  );
}
